import React, { Component } from "react";
import { Grid, Row, Col, Image, Modal } from "react-bootstrap";
import './About.css';

export default class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showVideo: false
    };
  }
  handleVideo = (e) => {
    e.preventDefault();
    this.setState({ showVideo: true });
  }
  handleClose = () => {
    this.setState({ showVideo: false });
  }
  render() {
    return (
      
      <div className="About">
        <div class="bar"></div>
        <Grid>
          <Row>
            <Col md={6} className="text">
              <h3 className="title">Sobre Nosotros</h3>
            </Col>
          </Row>
          <Row>
            <Col md={6} className="text">
              <p>
              Durante la última década PizarroVial Constructora ha sido protagonista del
              desarrollo y construcción de variados proyectos de mediana y gran escala en
              territorio nacional.
              </p>
              <p>
              Nuestra experiencia nos ha llevado a ser reconocidos en el sector por la
              calidad, compromiso y responsabilidad al ejecutar los proyectos.
              </p>
              <p>
              Cuidamos la confianza depositada por nuestros clientes integrándonos en la
              construcción de sus proyectos, consolidando el compromiso en desarrollar
              calidad.
              </p>
              {/* <center className="videoImage">
                <Image src="images/video.gif" onClick={this.handleVideo}/>
              </center> */}
            </Col>
            {/* <Col md={6}>
              <Image src="/images/about.jpg" responsive />
            </Col> */}
          </Row>
        </Grid>
        {/* <Modal show={this.state.showVideo} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Pizarro Vial Constructora</Modal.Title>
          </Modal.Header>
          <Modal.Body className="video-container">
            <iframe title="Pizarro Vial Constructora" width="560" height="315" src="https://www.youtube.com/embed/mu4ICY1dnXg?rel=0&amp;showinfo=0&autoplay=1&loop=1&playlist=mu4ICY1dnXg" frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
          </Modal.Body>
        </Modal> */}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/About.js